import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconAspectRatio43: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAspectRatio43"><Rect x="2" y="4" width="20" height="16" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio43;
